import React, {useState} from 'react';
import './App.css';

const apiKey = '4cb8d60b-1436-4a66-b85c-5334e618e77f';
const apiUrl = 'https://api.thecatapi.com/v1/images/search';

function App(){
  const [catUrl, setCatUrl] = useState('./favicon.ico'); //Using React change the state of this with a replaced URL

  const getCat = () => {
    fetch(apiUrl, {
      headers: {
        'x-api-key': apiKey
      }
    })
      .then((res) => res.json())
      .then((cats) => {
        const catUrl = cats[0].url;
        setCatUrl(catUrl);
    })
      .catch((error) => {
        console.log('Error Occured: ', error)
      });
  }

//React JSX (JS XML)
return(
  <body>
  <title>The Cat Randomiser App!</title>
  <div className='mainContainer'>
    <h1>The Cat Randomiser App!</h1>
    <img src={catUrl} alt=""/>
    <br></br>
    <h2>Press the button below to get a random cat appear above!</h2>
    <button onClick={getCat}>Please Press Me!</button>
  </div>
  </body>
)
}

export default App;